// extracted by mini-css-extract-plugin
module.exports = {"pageColumn":"style-module__pageColumn___JsYaZ"};